<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>{{ typeName }}区域</h4>
      </div>
      <div class="c-flex">
        <el-select
          v-if="tenantId == '1340835581184723420'"
          style="margin-right: 10px"
          width="300px"
          v-model="searchServiceType"
          placeholder="服务类型筛选"
          clearable
          value-key="index"
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, i) in options.serviceType"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          :placeholder="`请输入${typeName}区域名称`"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew(1)" class="c-m-l-10">
          新增{{ typeName }}区域
        </el-button>
        <!-- <el-button type="primary" @click="doNew(2)" class="c-m-l-10">
          新增{{ typeName }}区域关键词
        </el-button> -->

        <el-button
          type="primary"
          class="c-m-l-10"
          v-if="osg.has('ServiceTerritories,export')"
          @click="
            osg.doExport({
              'fpi-regex:name|string#or': searchValue,
              beanName: 'serviceTerritory',
              title: `${typeName}区域`
            })
          "
        >
          数据导出
        </el-button>
        <!-- 闭水 -->
        <!-- <el-popover
          width="200"
          v-if="tenantId == '4551453470943235290'"
          popper-class="c-popper"
          @show="osg.colSetShow"
        >
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover> -->
      </div>
    </div>
    <!-- 闭水 -->
    <!-- <div class="content-box" v-if="tenantId == '4551453470943235290'">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields">
            <templates slot="relatedIds">
              <el-table-column
                prop="relatedIds"
                :label="`${typeName}资源`"
                width="300px"
                show-overflow-tooltip
                :formatter="formatRelatedIds"
              ></el-table-column>
            </templates>
            <templates slot="province">
              <el-table-column label="省" width="100px" prop="province" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatProvinces(scope.row.province) }}
                </template>
              </el-table-column>
            </templates>
            <templates slot="city">
              <el-table-column label="市" width="100px" prop="city" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatCitys(scope.row.city) }}
                </template>
              </el-table-column>
            </templates>
            <templates slot="district">
              <el-table-column label="区" width="100px" prop="district" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatDistricts(scope.row.district) }}
                </template>
              </el-table-column>
            </templates>
          </c-table>

          <el-table-column fixed="right" width="110" label="操作">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div> -->
    <div class="content-box" v-if="tenantId !== '4551453470943235290'">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data" highlight-current-row>
          <el-table-column
            prop="territoryNum"
            label="服务区域编号"
            width="100px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="`${typeName}区域名称`" width="200px" prop="name">
            <template slot-scope="scope">
              <el-button @click.native.prevent="handleRowClick(scope.row)" type="text">
                {{ scope.row.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="serviceType"
            label="服务类型"
            :formatter="formatServiceType"
            width="200px"
          ></el-table-column>
          <el-table-column
            prop="relatedIds"
            :label="`${typeName}资源`"
            width="250px"
            show-overflow-tooltip
            :formatter="formatRelatedIds"
          ></el-table-column>
          <el-table-column
            label="省"
            width="100px"
            prop="province"
            show-overflow-tooltip
            v-if="areaShow"
          >
            <template slot-scope="scope">
              {{ formatProvinces(scope.row.province) }}
            </template>
          </el-table-column>
          <el-table-column
            label="市"
            width="100px"
            prop="city"
            show-overflow-tooltip
            v-if="areaShow"
          >
            <template slot-scope="scope">
              {{ formatCitys(scope.row.city) }}
            </template>
          </el-table-column>
          <el-table-column
            label="区"
            width="100px"
            prop="district"
            show-overflow-tooltip
            v-if="areaShow"
          >
            <template slot-scope="scope">
              {{ formatDistricts(scope.row.district) }}
            </template>
          </el-table-column>
          <el-table-column
            label="街道"
            width="300px"
            prop="subdistrict"
            show-overflow-tooltip
            v-if="areaShow"
          >
            <template slot-scope="scope">
              {{ formatSubdistricts(scope.row.subdistrict) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="community"
            label="小区"
            width="100px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.code"
            label="区域编码"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="postalCode"
            label="邮编"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="description"
            label="描述"
            width="220px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="keywords"
            label="关键词"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <!-- 闭水 -->
    <!-- <el-dialog
      title="服务区域信息"
      :visible.sync="openDetail"
      v-if="tenantId == '4551453470943235290'"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="110px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="服务区域名称" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入服务区域名称"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '服务区域名称不能为空'
            }"
          ></el-input>
        </el-form-item>
        <el-form-item label="省市区街道" prop="area">
          <el-cascader
            v-if="area.show"
            :options="area.options"
            :props="area.props"
            v-model="formData.area"
            collapse-tags
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="formData.description" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog> -->
    <el-dialog
      :title="`${typeName}区域信息`"
      :visible.sync="openDetail"
      v-if="tenantId !== '4551453470943235290'"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="110px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="编号" prop="territoryNum">
          <el-input
            :controls="false"
            v-model="formData.territoryNum"
            placeholder="请输入编号"
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${typeName}区域名称`" prop="name">
          <el-input
            v-model="formData.name"
            :placeholder="`请输入${typeName}区域名称`"
            :rules="{
              required: true,
              trigger: 'blur',
              message: `${typeName}区域名称不能为空`
            }"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务类型" prop="serviceType">
          <el-select
            v-model="formData.serviceType"
            multiple
            multiple-limit="1"
            placeholder="请选择服务类型"
          >
            <el-option
              v-for="item in options.serviceType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家" prop="country">
          <el-input v-model="formData.country" placeholder="请输入国家"></el-input>
        </el-form-item>
        <div v-if="doNewValue == 1">
          <el-form-item label="省市区街道" prop="area">
            <el-cascader
              v-if="area.show"
              :options="area.options"
              :props="area.props"
              v-model="formData.area"
              collapse-tags
              clearable
            ></el-cascader>
          </el-form-item>
        </div>
        <div v-if="doNewValue == 2">
          <el-form-item label="省市区街道" prop="area">
            <el-cascader
              v-if="unArea.show"
              :options="unArea.options"
              :props="unArea.props"
              v-model="formData.area"
              collapse-tags
              clearable
            ></el-cascader>
          </el-form-item>
        </div>

        <el-form-item label="小区" prop="community">
          <el-input v-model="formData.community" placeholder="请输入小区"></el-input>
        </el-form-item>
        <el-form-item label="区域编码" prop="exts.code">
          <el-input v-model="formData.exts.code" placeholder="请输入区域编码"></el-input>
        </el-form-item>
        <el-form-item label="邮编" prop="postalCode">
          <el-input v-model="formData.postalCode" placeholder="请输入邮编"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="formData.description" placeholder="请输入描述"></el-input>
        </el-form-item>
        <div v-if="doNewValue == 2">
          <el-form-item label="关键词" prop="keywords">
            <el-input v-model="formData.keywords" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </div>

        <!-- <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList4.js';
import { mapMutations } from 'vuex';
export default {
  activated() {
    window.$this = this;
  },
  name: 'serviceTerritory',
  data() {
    window.$this = this;
    let that = this;
    return {
      savedStreet: '', //row中已保存的街道
      // gitSame: [], //相同数据
      gitDiff: [], // 不同数据
      doSaveDisableArr: [], //编辑确定后勾选中的街道
      notdDisableArr: [], //编辑时街道数据
      tenantId: '',
      typeName: '服务',
      refresh: true,
      name: 'serviceTerritory',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        country: '中国',
        area: [],
        serviceType: [],
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_serviceType: { codeId: 'serviceType' }
      },
      areaList: this.$util.deepCopy(this.osg.areaList),
      //地址级联
      area: {
        options: this.areaList,
        show: true,
        props: {
          multiple: true,
          lazy: that.tenantId == '4363416483534256239' ? false : true,
          async lazyLoad(node, resolve) {
            const { level } = node;
            var nodes = [];
            if (level == '3') {
              node.data.leaf = false;
              // if (node.children && node.children.length == 0) {
              node.children = [];
              let id = node.data.value;
              if (
                that.formData.serviceType == '' ||
                typeof that.formData.serviceType == 'undefined'
              ) {
                that.osg.alert('请先选择服务类型');
                return;
              }
              await that.getDataAllStreet();
              let arr = that.subdistrictT.concat(that.doSaveDisableArr, that.gitDiff);
              // console.log('arr-------',that.arr)
              // let arr1 = that.notdDisableArr;

              nodes = await that.$util.getSubdistrict(id, arr, that.savedStreet, 'areaTranslation');
              that.$set(that.formData, 'area', that.formData.area);
              if (nodes.length == 0) {
                node.data.leaf = true;
              }
              // }
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        }
      },
      // 不去重查街道
      unArea: {
        options: this.areaList,
        show: true,
        props: {
          multiple: true,
          lazy: that.tenantId == '4363416483534256239' ? false : true,
          async lazyLoad(node, resolve) {
            const { level } = node;
            var nodes = [];
            if (level == '3') {
              node.data.leaf = false;
              // if (node.children && node.children.length == 0) {
              node.children = [];
              let id = node.data.value;
              // if (
              //   that.formData.serviceType == '' ||
              //   typeof that.formData.serviceType == 'undefined'
              // ) {
              //   that.osg.alert('请先选择服务类型');
              //   return;
              // }
              // await that.getDataAllStreet();
              let arr = that.subdistrictT.concat(that.doSaveDisableArr, that.gitDiff);
              // console.log('arr-------',that.arr)
              // let arr1 = that.notdDisableArr;

              nodes = await that.$util.UnGetSubdistrict(id, arr, null, 'areaTranslation');
              that.$set(that.formData, 'area', that.formData.area);
              if (nodes.length == 0) {
                node.data.leaf = true;
              }
              // }
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        }
      },
      // 返显服务区域关联的服务资源
      serviceResources: [],
      areaShow: true, //视图刷新用
      subdistrictT: [], //数据中的街道
      searchServiceType: '',
      doNewValue: '' //添加按钮val
    };
  },
  beforeCreate() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.getServiceResources();
    this.osg.getFields('serviceTerritory', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    ...mapMutations(['SetCachedViews']),
    formatServiceType(row, column, cellValue) {
      return this.osg.codelabelForArray('serviceType', cellValue);
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatProvinces(value) {
      if (!value) return;
      let str = '';
      for (var item of value) {
        str += this.osg.areaObj.province_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatCitys(value) {
      if (!value) return;
      let str = '';
      for (var item of value) {
        str += this.osg.areaObj.city_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatDistricts(value) {
      if (!value) return;
      let str = '';
      for (var item of value) {
        str += this.osg.areaObj.county_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatSubdistricts(value) {
      if (!value) return;
      let str = '';
      for (var item of value) {
        str += this.osg.areaObj.street_list[item] + '、';
      }
      return str.substring(0, str.length - 1);
    },
    formatRelatedIds(row, column, cellValue) {
      let str = '';
      let relatedIds = cellValue || [];
      for (let i = 0; i < relatedIds.length; i++) {
        for (let serviceResource of this.serviceResources) {
          if (relatedIds[i] == serviceResource._id) {
            str += i + 1 + '.' + serviceResource.name + ' ';
          }
        }
      }
      return str;
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { area: [], exts: {} };
      this.doNewValue = '';
      this.$forceUpdate();
      // if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);

      this.areaList.map(province => {
        province.children.map(city => {
          city.children.map(district => {
            district.leaf = true;
            district.children = [];
          });
        });
      });
      this.area.options = this.areaList;
      this.unArea.options = this.areaList;
    },
    // 请求全部数据中已保存的街道，用于判断街道去重
    getDataAllStreet() {
      return new Promise(resolve => {
        var params = {
          _all: '1',
          'in:state|array-integer#and': '0,1',
          'regex:name|string#or': this.searchValue,
          'in:serviceType|array#and': this.formData.serviceType.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        };
        //添加过滤器参数
        // this.getParams(params);
        this.osg.setFpi(params);
        this.osg.ajax('basic/serviceTerritory/query.do', params, res => {
          res.data.map(item => {
            this.subdistrictT = this.subdistrictT.concat(...item.subdistrict);
            console.log('subdistrictT-----', this.subdistrictT);
          });

          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
          resolve(res.data);
        });
      });
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'is:serviceType|string#and': this.searchServiceType,
        sortField: 'territoryNum,createTime',
        sortOrder: 'asc'
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/serviceTerritory/query.do', params, res => {
        // this.getDataAllStreet();
        res.data.map(item => {
          //解析json格式的area
          if (this.$util.isJson(item.area)) {
            item.area = JSON.parse(item.area);
          }
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // val 1、去重area 2、不去重
    doNew(val) {
      this.doInit();
      this.doNewValue = val;
      console.log(this.doNewValue, '---this.doNewValue');
      this.openDetail = true;

      this.area.show = false;
      this.$nextTick(() => {
        this.area.show = true;
      });
    },
    doEdit(row) {
      if (row.exts.iskeyword == '1') {
        this.doNewValue = 2;
      } else {
        this.doNewValue = 1;
      }
      row.serviceType[0];
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      if (this.$util.isJson(row.area)) {
        row.area = JSON.parse(row.area);
      }

      // 往区插入下级街道数据
      let districts = [];
      let addDistricts = [];
      row.area.map(area => {
        if (area.length == 4 && districts.indexOf(area[2]) == -1) {
          districts.push(area[2]);
          addDistricts.push(area);
        }
      });
      if (districts.length > 0) {
        this.getSubdistricts(districts, subdistricts => {
          this.addSubdistricts(addDistricts, subdistricts, row);
          this.formData = row;
          this.area.show = false;
          this.openDetail = true;
          this.$nextTick(() => {
            this.area.show = true;
          });
        });
      } else {
        this.formData = row;
        this.area.show = false;
        this.openDetail = true;
        this.$nextTick(() => {
          this.area.show = true;
        });
      }
    },
    getSubdistricts(districts, callback) {
      this.osg.ajax(
        'area/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterTenantId: '1',
          'in:parentCode|array#and': districts.join(),
          level: '4',
          sortField: 'code',
          sortOrder: 'asc'
        },
        res => {
          res.data.map(item => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = true;
          });
          if (callback) {
            callback(res.data);
          }
        },
        {
          noload: true
        }
      );
    },
    addSubdistricts(areaList, subdistricts, row) {
      this.notdDisableArr = row.area.map((item, index) => row.area[index][3]);
      console.log(this.notdDisableArr, '------notdDisableArr编辑前数据');
      areaList.map(area => {
        for (let i = 0; i < this.areaList.length; i++) {
          let province = this.areaList[i];
          if (province.value == area[0]) {
            for (let j = 0; j < province.children.length; j++) {
              let city = province.children[j];
              if (city.value == area[1]) {
                for (let k = 0; k < city.children.length; k++) {
                  let district = city.children[k];
                  if (district.value == area[2]) {
                    district.children = [];
                    district.leaf = false;
                    subdistricts.map(subdistrict => {
                      subdistrict.disabled =
                        !this.gitDiff.includes(subdistrict.value) &&
                        !this.notdDisableArr.includes(subdistrict.value) &&
                        // this.subdistrictT.includes(subdistrict.value)
                        this.subdistrictT.indexOf(subdistrict.value) !== -1;
                      this.savedStreet = row.subdistrict;
                      // subdistrict.disabled = this.subdistrictT.indexOf(subdistrict.value) == -1 ? false:true;
                      if (subdistrict.parentCode == district.value) {
                        district.children.push(subdistrict);
                      }
                    });
                    break;
                  }
                }
                break;
              }
            }
            break;
          }
        }
      });
    },
    doSave() {
      if (this.osg.validate()) {
        // 判断是关键词服务区域时exts.iskeyword：1
        if (this.doNewValue == 2) {
          this.formData.exts.iskeyword = '1';
        }
        let params = this.$util.deepCopy(this.formData);
        //省市区支持多选
        params.area = params.area || [];
        let province = [];
        let city = [];
        let district = [];
        let subdistrict = [];
        for (let item of params.area) {
          if (province.indexOf(item[0]) == -1) province.push(item[0]);
          if (city.indexOf(item[1]) == -1) city.push(item[1]);
          if (district.indexOf(item[2]) == -1) district.push(item[2]);
          if (subdistrict.indexOf(item[3]) == -1) subdistrict.push(item[3]);
        }
        params.province = province;
        params.city = city;
        params.district = district;
        params.subdistrict = subdistrict;
        params.area = JSON.stringify(params.area);
        this.$util.saveExtField(this.extFields, this.formData);
        // console.log(params, '---params');
        // console.log(typeof params.exts.orderNumber, '---typeof');
        this.osg.ajax('basic/serviceTerritory/upsert.do', params, res => {
          this.doSaveDisableArr = res.data.subdistrict;
          console.log(this.doSaveDisableArr, '------doSaveDisableArr编辑后数据');
          // 找不同元素
          this.gitDiff = this.notdDisableArr
            .concat(this.doSaveDisableArr)
            .filter((item, index, arr) => arr.indexOf(item) === arr.lastIndexOf(item));
          console.log(this.gitDiff, '--------gitDiff不同元素');
          // 找相同元素
          // this.gitSame =[...new Set(this.notdDisableArr)].filter(item =>
          //   this.doSaveDisableArr.includes(item))
          // console.log(this.gitSame, '--------gitSame相同元素');
          this.doInit();
          this.getData();
          // this.getDataAllStreet()
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/serviceTerritory/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/serviceTerritory/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('确定删除吗？', () => {
        this.osg.ajax(`basic/serviceTerritory/remove/${id}.do`, null, res => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    getServiceResources() {
      let params = {
        'in:state|array-integer#and': '0,1',
        _all: '1'
      };
      // TODO:dzm服务区域只关联伙伴类型的服务资源
      if (this.tenantId == '1340835581184723420') {
        params['is:resourceType|string#and'] = 'partner';
      }
      this.osg.ajax(
        'biz/serviceResource/query.do',
        params,
        res => {
          if (res.data) {
            this.serviceResources = res.data;
          }
        },
        {
          noload: true
        }
      );
    },
    handleRowClick(row) {
      this.$router.push({
        path: `/ServiceTerritory/${row._id}`
      });
      this.SetCachedViews({ params: row.name, action: `/ServiceTerritory/${row._id}` });
    }
  }
};
</script>
<style lang="scss">
.header-50 {
  height: 51px !important;
}
</style>
